@if (isMbGroup) {
  <p class="tw-mt-7.5 md:tw-mt-0">
    {{ 'screens.personalInformation.requiredFields' | translate }}
  </p>
}

<form
  class="mb-group:tw-mt-7.5 hb-group:tw-text-hb-brand-1100"
  [formGroup]="personalInformationForm"
>
  <ia-panel>
    <div header class="tw-flex tw-w-full tw-flex-row tw-justify-between">
      <span>{{ 'screens.personalInformation.panel.title' | translate }}</span>
    </div>
    <div content>
      <div class="tw-mb-7.5 mb-group:tw-mx-7.5 mb-group:tw-pt-10">
        @if (isConnected && isHb) {
          <div class="tw-mt-4 tw-rounded-2xl tw-border tw-border-porcelain">
            @for (item of connectedValues(); track item; let idx = $index) {
              @if (item.value) {
                <div
                  class="tw-flex tw-border-t tw-border-porcelain tw-p-6 tw-text-hb-base first:tw-border-none"
                >
                  <span class="tw-basis-1/3 tw-font-semibold"> {{ item.key }}</span>
                  <span class="tw-basis-2/3"> {{ item.value }}</span>
                </div>
              }
            }
          </div>
        } @else {
          @if (isMbGroup) {
            <label
              class="mb-group:tw-font-semibold connected:tw-text-gray"
              for="input-personal-information-identification-physical-person"
              >{{ 'screens.personalInformation.panel.identification.label' | translate }}</label
            >
            <div class="hb-group:md:tw-flex hb-group:md:tw-gap-4">
              <div class="tw-mt-4 tw-flex tw-items-center">
                <input
                  [value]="PhysicalPerson"
                  formControlName="identification"
                  id="input-personal-information-identification-physical-person"
                  data-test-id="input-personal-information-identification-physical-person"
                  name="identification"
                  type="radio"
                  iaSharedRadio
                />
                <label
                  for="input-personal-information-identification-physical-person"
                  class="tw-ml-3 connected:tw-text-gray not-connected:tw-cursor-pointer"
                  >{{
                    'screens.personalInformation.panel.identification.physicalPerson' | translate
                  }}</label
                >
              </div>

              <div class="tw-flex tw-items-center mb-group:tw-mt-5 hb-group:tw-mt-4">
                <input
                  [value]="LegalPerson"
                  formControlName="identification"
                  id="input-personal-information-identification-legal-person"
                  data-test-id="input-personal-information-identification-legal-person"
                  name="identification"
                  type="radio"
                  iaSharedRadio
                />
                <label
                  for="input-personal-information-identification-legal-person"
                  class="tw-ml-3 connected:tw-text-gray not-connected:tw-cursor-pointer"
                  >{{
                    'screens.personalInformation.panel.identification.legalPerson' | translate
                  }}</label
                >
              </div>
              @if (isMbGroup) {
                <p class="tw-ml-8 tw-text-base tw-text-gray">
                  {{
                    'screens.personalInformation.panel.identification.legalPersonInfo' | translate
                  }}
                </p>
              }
            </div>
          }

          @if (identificationValue === PhysicalPerson) {
            <div class="tw-mt-7.5">
              <label
                class="mb-group:tw-font-semibold connected:tw-text-gray"
                for="input-personal-information-gender-man"
                >{{ 'screens.personalInformation.panel.gender.label' | translate }}</label
              >
              <div class="hb-group:tw-flex-col hb-group:md:tw-flex">
                <div class="tw-mt-4 tw-flex tw-items-center">
                  <input
                    [value]="1"
                    formControlName="gender"
                    id="input-personal-information-gender-man"
                    data-test-id="input-personal-information-gender-man"
                    name="gender"
                    type="radio"
                    iaSharedRadio
                  />
                  <label
                    for="input-personal-information-gender-man"
                    class="tw-ml-3 hb-group:tw-text-hb-base connected:tw-text-gray not-connected:tw-cursor-pointer"
                  >
                    {{ 'screens.personalInformation.panel.gender.man' | translate }}</label
                  >
                </div>
                <div class="tw-flex tw-items-center mb-group:tw-mt-5 hb-group:tw-mt-3">
                  <input
                    [value]="2"
                    formControlName="gender"
                    id="input-personal-information-gender-woman"
                    data-test-id="input-personal-information-gender-woman"
                    name="gender"
                    type="radio"
                    iaSharedRadio
                  />
                  <label
                    for="input-personal-information-gender-woman"
                    class="tw-ml-3 hb-group:tw-text-hb-base connected:tw-text-gray not-connected:tw-cursor-pointer"
                    >{{ 'screens.personalInformation.panel.gender.woman' | translate }}</label
                  >
                </div>
              </div>
              @if (
                personalInformationForm.get('gender')?.touched &&
                personalInformationForm.get('gender')?.value === 0
              ) {
                <ia-resil-contrats-error-message
                  [message]="'screens.personalInformation.panel.gender.error.required' | translate"
                />
              }
            </div>
          }

          <div class="tw-mt-7.5">
            @if (identificationValue === PhysicalPerson) {
              <label
                class="mb-group:tw-font-semibold hb-group:tw-text-hb-sm hb-group:tw-font-medium connected:tw-text-gray"
                for="input-personal-information-full-name"
                >{{ 'screens.personalInformation.panel.fullName.label' | translate }}</label
              >
            }
            @if (identificationValue === LegalPerson) {
              <div class="tw-block tw-items-center sm:tw-inline-flex">
                <label
                  class="mb-group:tw-font-semibold hb-group:tw-text-hb-sm hb-group:tw-font-medium connected:tw-text-gray"
                  for="input-personal-information-full-name"
                  >{{ 'screens.personalInformation.panel.companyName.label' | translate }}</label
                >
              </div>
            }
            <input
              [error]="fullName.touched && fullName.invalid"
              [placeholder]="'screens.personalInformation.panel.fullName.placeholder' | translate"
              mask="A*"
              [patterns]="specialCharactersNotAllowed"
              [dropSpecialCharacters]="false"
              class="tw-w-full tw-cursor-auto focus-visible:focus-visible:tw-outline-none disabled:tw-bg-seasalt hb-group:tw-mt-0 hb-group:tw-w-full connected:tw-text-gray md:tw-w-75 hb-group:md:tw-w-1/2"
              formControlName="fullName"
              iaInput
              [disabled]="isConnected"
              id="input-personal-information-full-name"
              data-test-id="input-personal-information-full-name"
            />
            @if (fullName.touched && fullName.hasError('required')) {
              <ia-resil-contrats-error-message
                [message]="'screens.personalInformation.panel.fullName.error.required' | translate"
              />
            }
          </div>

          @if (
            (isConnected && identificationValue === PhysicalPerson && firstNameValue) ||
            (!isConnected && identificationValue === PhysicalPerson)
          ) {
            <div class="tw-my-7.5">
              <label
                class="mb-group:tw-font-semibold hb-group:tw-text-hb-sm hb-group:tw-font-medium connected:tw-text-gray"
                for="input-personal-information-first-name"
                >{{ 'screens.personalInformation.panel.firstName.label' | translate }}</label
              >
              <input
                [error]="firstName.touched && firstName.invalid"
                [placeholder]="
                  'screens.personalInformation.panel.firstName.placeholder' | translate
                "
                mask="A*"
                [patterns]="specialCharactersNotAllowed"
                [dropSpecialCharacters]="false"
                class="tw-w-full tw-cursor-auto focus-visible:focus-visible:tw-outline-none disabled:tw-bg-seasalt hb-group:tw-mt-0 hb-group:tw-w-full connected:tw-text-gray md:tw-w-75 hb-group:md:tw-w-1/2"
                formControlName="firstName"
                [disabled]="isConnected"
                iaInput
                id="input-personal-information-first-name"
                data-test-id="input-personal-information-first-name"
              />
              @if (firstName.touched && firstName.hasError('required')) {
                <ia-resil-contrats-error-message
                  [message]="
                    'screens.personalInformation.panel.firstName.error.required' | translate
                  "
                />
              }
            </div>
          }

          @if (identificationValue === LegalPerson) {
            <div>
              <div class="tw-mt-7.5">
                <label
                  for="input-personal-information-applicant-last-name"
                  class="tw-font-semibold"
                  >{{
                    'screens.personalInformation.panel.applicantLastName.label' | translate
                  }}</label
                >
                <input
                  [error]="applicantLastName.touched && applicantLastName.invalid"
                  [placeholder]="
                    'screens.personalInformation.panel.applicantLastName.placeholder' | translate
                  "
                  class="tw-w-full focus-visible:focus-visible:tw-outline-none hb-group:tw-mt-0 hb-group:tw-w-full md:tw-w-75 hb-group:md:tw-w-1/2"
                  formControlName="applicantLastName"
                  mask="A*"
                  [patterns]="specialCharactersNotAllowed"
                  [dropSpecialCharacters]="false"
                  iaInput
                  [disabled]="isConnected && !isPro"
                  id="input-personal-information-applicant-last-name"
                  data-test-id="input-personal-information-applicant-last-name"
                  type="text"
                />
              </div>
              @if (applicantLastName.touched && applicantLastName.hasError('required')) {
                <ia-resil-contrats-error-message
                  [message]="
                    'screens.personalInformation.panel.applicantLastName.error.required' | translate
                  "
                />
              }
            </div>
          }

          @if (identificationValue === LegalPerson) {
            <div>
              <div class="tw-mt-7.5">
                <label
                  for="input-personal-information-applicant-first-name"
                  class="tw-font-semibold"
                  >{{
                    'screens.personalInformation.panel.applicantFirstName.label' | translate
                  }}</label
                >
                <input
                  [error]="applicantFirstName.touched && applicantFirstName.invalid"
                  [placeholder]="
                    'screens.personalInformation.panel.applicantFirstName.placeholder' | translate
                  "
                  class="tw-w-full focus-visible:focus-visible:tw-outline-none hb-group:tw-mt-0 hb-group:tw-w-full md:tw-w-75 hb-group:md:tw-w-1/2"
                  formControlName="applicantFirstName"
                  mask="A*"
                  [patterns]="specialCharactersNotAllowed"
                  [dropSpecialCharacters]="false"
                  [disabled]="isConnected && !isPro"
                  iaInput
                  id="input-personal-information-applicant-first-name"
                  data-test-id="input-personal-information-applicant-first-name"
                  type="text"
                />
              </div>
              @if (applicantFirstName.touched && applicantFirstName.hasError('required')) {
                <ia-resil-contrats-error-message
                  [message]="
                    'screens.personalInformation.panel.applicantFirstName.error.required'
                      | translate
                  "
                />
              }
            </div>
          }

          @if (identificationValue === PhysicalPerson || !isConnected) {
            <div class="tw-mt-7.5">
              <label
                class="mb-group:tw-font-semibold hb-group:tw-text-hb-sm hb-group:tw-font-medium connected:tw-text-gray"
                for="input-personal-information-date-of-birth-disabled"
              >
                @if (identificationValue === PhysicalPerson) {
                  {{ 'screens.personalInformation.panel.dateOfBirth.label' | translate }}
                }
                @if (identificationValue === LegalPerson) {
                  {{ 'screens.personalInformation.panel.dateOfBirth.labelApplicant' | translate }}
                }
              </label>
              @if (!isConnected) {
                <ia-datepicker
                  class="tw-mt-1.5 tw-block tw-w-full md:tw-w-75 hb-group:md:tw-w-1/2"
                  [inputClass]="{
                    '!tw-px-4 tw-text-gray mb-group:tw-shadow-inner hb-group:tw-mt-0 focus-visible:focus-visible:tw-outline-none': true,
                  }"
                  [inputConfig]="{
                    containerClass:
                      'ia-datepicker tw-rounded-[3px]' +
                      (dateOfBirth.invalid && dateOfBirth.touched
                        ? 'tw-border tw-border-tomato tw-rounded-[3px]'
                        : ''),
                  }"
                  formControlName="dateOfBirth"
                  id="input-personal-information-date-of-birth"
                />
              }
              @if (isConnected) {
                <input
                  class="tw-w-full tw-cursor-auto tw-text-gray focus-visible:focus-visible:tw-outline-none disabled:tw-bg-seasalt hb-group:tw-mt-0 hb-group:tw-w-full md:tw-w-75 hb-group:md:tw-w-1/2"
                  formControlName="dateOfBirth"
                  iaInput
                  id="input-personal-information-date-of-birth-disabled"
                  data-test-id="input-personal-information-date-of-birth-disabled"
                />
              }
              @if (dateOfBirth.touched && dateOfBirth.hasError('required')) {
                <ia-resil-contrats-error-message
                  [message]="
                    'screens.personalInformation.panel.dateOfBirth.error.required' | translate
                  "
                />
              }
            </div>
          }
        }

        @if (
          identificationValue === PhysicalPerson ||
          !isConnected ||
          (isHb && isConnected && !countryOfBirth.value)
        ) {
          <div>
            <div class="tw-mt-7.5">
              <label
                for="input-personal-information-country-of-birth"
                class="tw-font-semibold hb-group:tw-text-hb-sm hb-group:tw-font-medium"
              >
                @if (identificationValue === PhysicalPerson) {
                  {{ 'screens.personalInformation.panel.countryOfBirth.label' | translate }}
                }
                @if (identificationValue === LegalPerson) {
                  {{
                    'screens.personalInformation.panel.countryOfBirth.labelApplicant' | translate
                  }}
                }
              </label>
              <input
                [error]="countryOfBirth.touched && countryOfBirth.invalid"
                [placeholder]="
                  'screens.personalInformation.panel.countryOfBirth.placeholder' | translate
                "
                class="tw-w-full focus-visible:focus-visible:tw-outline-none hb-group:tw-mt-0 hb-group:tw-w-full md:tw-w-75 hb-group:md:tw-w-1/2"
                formControlName="countryOfBirth"
                mask="A*"
                [patterns]="specialCharactersNotAllowed"
                [dropSpecialCharacters]="false"
                iaInput
                id="input-personal-information-country-of-birth"
                data-test-id="input-personal-information-country-of-birth"
                type="text"
              />
            </div>
            @if (countryOfBirth.touched && countryOfBirth.hasError('required')) {
              <ia-resil-contrats-error-message
                [message]="
                  'screens.personalInformation.panel.countryOfBirth.error.required' | translate
                "
              />
            }
          </div>
        }

        @if (
          identificationValue === PhysicalPerson ||
          !isConnected ||
          (isHb && isConnected && !countryOfBirth.value)
        ) {
          <div>
            <div class="tw-mt-7.5">
              <label
                for="input-personal-information-commune-of-birth"
                class="tw-font-semibold hb-group:tw-text-hb-sm hb-group:tw-font-medium"
              >
                @if (identificationValue === PhysicalPerson) {
                  {{ 'screens.personalInformation.panel.communeOfBirth.label' | translate }}
                }
                @if (identificationValue === LegalPerson) {
                  {{
                    'screens.personalInformation.panel.communeOfBirth.labelApplicant' | translate
                  }}
                }
              </label>
              <input
                [error]="communeOfBirth.touched && communeOfBirth.invalid"
                [placeholder]="
                  'screens.personalInformation.panel.communeOfBirth.placeholder' | translate
                "
                class="tw-w-full focus-visible:focus-visible:tw-outline-none hb-group:tw-mt-0 hb-group:tw-w-full md:tw-w-75 hb-group:md:tw-w-1/2"
                formControlName="communeOfBirth"
                mask="A*"
                [patterns]="specialCharactersNotAllowed"
                [dropSpecialCharacters]="false"
                iaInput
                id="input-personal-information-commune-of-birth"
                data-test-id="input-personal-information-commune-of-birth"
                type="text"
              />
            </div>
            @if (communeOfBirth.touched && communeOfBirth.hasError('required')) {
              <ia-resil-contrats-error-message
                [message]="
                  'screens.personalInformation.panel.communeOfBirth.error.required' | translate
                "
              />
            }
          </div>
        }

        <div class="tw-mt-7.5">
          <label
            class="mb-group:tw-font-semibold"
            for="input-personal-information-channel-type-email"
            >{{ 'screens.personalInformation.panel.channelType.label' | translate }}</label
          >
          <ia-tooltip
            colorClass="tw-text-gray hb-group:tw-text-midnight-green hb-group:tw-w-5 hb-group:tw-h-5"
            tooltipContainerClass="tw-border tw-border-platinum tw-absolute tw--left-8 tw-w-56 tw-rounded-md tw-bg-white tw-px-4 tw-py-5 tw-text-left tw-text-md tw-text-gray "
            class="tw-ml-2.5"
            icon="i"
          >
            {{ 'screens.personalInformation.panel.channelType.tooltip' | translate }}
          </ia-tooltip>
          <div class="hb-group:tw-flex-col hb-group:md:tw-flex">
            <div class="hb-group:tw-flex-col">
              <div class="tw-mt-4 tw-flex tw-items-center">
                <input
                  [value]="Email"
                  iaSharedRadio
                  type="radio"
                  formControlName="channelType"
                  name="channelType"
                  id="input-personal-information-channel-type-email"
                  data-test-id="input-personal-information-channel-type-email"
                />
                <div>
                  <label
                    for="input-personal-information-channel-type-email"
                    class="tw-ml-3 tw-cursor-pointer hb-group:tw-text-hb-base"
                    >{{ 'screens.personalInformation.panel.channelType.email' | translate }}</label
                  >
                </div>
              </div>
            </div>
            <div
              class="tw-flex tw-items-center mb-group:tw-mt-5 hb-group:tw-mt-4 hb-group:tw-self-start"
            >
              <input
                [value]="Paper"
                iaSharedRadio
                type="radio"
                formControlName="channelType"
                name="channelType"
                id="input-personal-information-channel-type-paper"
                data-test-id="input-personal-information-channel-type-paper"
              />
              <label
                for="input-personal-information-channel-type-paper"
                class="tw-ml-3 tw-cursor-pointer hb-group:tw-text-hb-base"
                >{{ 'screens.personalInformation.panel.channelType.paper' | translate }}</label
              >
            </div>
          </div>
        </div>
        @if (channelType.touched && channelType.hasError('required')) {
          <ia-resil-contrats-error-message
            [message]="'screens.personalInformation.panel.channelType.error.required' | translate"
          />
        }

        @if (channelType.value === Email && isMbGroup) {
          <div>
            <div class="tw-mt-5">
              <label
                for="input-personal-information-email"
                class="tw-font-semibold hb-group:tw-uppercase hb-group:tw-text-slate-gray"
                >{{ 'screens.personalInformation.panel.email.label' | translate }}</label
              >
              <input
                [error]="email.touched && email.invalid"
                [placeholder]="'screens.personalInformation.panel.email.placeholder' | translate"
                class="tw-w-full focus-visible:focus-visible:tw-outline-none hb-group:tw-w-full md:tw-w-75 hb-group:md:tw-w-1/2"
                formControlName="email"
                iaInput
                id="input-personal-information-email"
                data-test-id="input-personal-information-email"
                type="text"
              />
            </div>
            @if (email.hasError('pattern')) {
              <ia-resil-contrats-error-message
                [message]="
                  'screens.personalInformation.panel.email.error.requiredPattern' | translate
                "
              />
            }
            @if (email.touched && email.hasError('required')) {
              <ia-resil-contrats-error-message
                [message]="'screens.personalInformation.panel.email.error.required' | translate"
              />
            }
          </div>
        }

        @if (channelType.value === Email && isHb) {
          <div>
            <div class="tw-mt-7.5">
              <label for="input-personal-information-email" class="tw-text-hb-sm tw-font-medium">{{
                'screens.personalInformation.panel.email.label' | translate
              }}</label>
              <input
                [error]="email.touched && email.invalid"
                [placeholder]="'screens.personalInformation.panel.email.placeholder' | translate"
                class="tw-mt-0 tw-w-full focus-visible:focus-visible:tw-outline-none hb-group:tw-w-full md:tw-w-75 hb-group:md:tw-w-1/2"
                formControlName="email"
                iaInput
                id="input-personal-information-email"
                data-test-id="input-personal-information-email"
                type="text"
              />
            </div>
            @if (email.hasError('pattern')) {
              <ia-resil-contrats-error-message
                [message]="
                  'screens.personalInformation.panel.email.error.requiredPattern' | translate
                "
              />
            }
            @if (email.touched && email.hasError('required')) {
              <ia-resil-contrats-error-message
                [message]="'screens.personalInformation.panel.email.error.required' | translate"
              />
            }
          </div>
        }

        @if (channelType.value === Paper) {
          <div>
            <div class="mb-group:tw-mt-5 hb-group:tw-mt-7.5">
              <label
                for="input-personal-information-address"
                class="tw-font-semibold hb-group:tw-text-hb-sm hb-group:tw-font-medium"
                >{{ 'screens.personalInformation.panel.address.label' | translate }}</label
              >
              <input
                [error]="address.touched && address.invalid"
                [placeholder]="'screens.personalInformation.panel.address.placeholder' | translate"
                class="tw-w-full focus-visible:focus-visible:tw-outline-none hb-group:tw-mt-0 hb-group:tw-w-full md:tw-w-75 hb-group:md:tw-w-1/2"
                formControlName="address"
                mask="A*"
                [patterns]="specialCharactersNotAllowed"
                [dropSpecialCharacters]="false"
                iaInput
                id="input-personal-information-address"
                data-test-id="input-personal-information-address"
                type="text"
              />
            </div>
            @if (address.touched && address.hasError('required')) {
              <ia-resil-contrats-error-message
                [message]="'screens.personalInformation.panel.address.error.required' | translate"
              />
            }
            <div class="tw-mt-7.5">
              <label
                for="input-personal-information-postal-code"
                class="tw-font-semibold hb-group:tw-text-hb-sm hb-group:tw-font-medium"
                >{{ 'screens.personalInformation.panel.postalCode.label' | translate }}</label
              >
              <input
                [error]="postalCode.touched && postalCode.invalid"
                [placeholder]="
                  'screens.personalInformation.panel.postalCode.placeholder' | translate
                "
                class="tw-w-full focus-visible:focus-visible:tw-outline-none hb-group:tw-mt-0 hb-group:tw-w-full md:tw-w-75 hb-group:md:tw-w-1/2"
                formControlName="postalCode"
                mask="A*"
                [patterns]="specialCharactersNotAllowed"
                [dropSpecialCharacters]="false"
                iaInput
                id="input-personal-information-postal-code"
                data-test-id="input-personal-information-postal-code"
                type="text"
              />
            </div>
            @if (postalCode.touched && postalCode.hasError('required')) {
              <ia-resil-contrats-error-message
                [message]="
                  'screens.personalInformation.panel.postalCode.error.required' | translate
                "
              />
            }
            <div class="tw-mt-7.5">
              <label
                for="input-personal-information-city"
                class="tw-font-semibold hb-group:tw-text-hb-sm hb-group:tw-font-medium"
                >{{ 'screens.personalInformation.panel.city.label' | translate }}</label
              >
              <input
                [error]="city.touched && city.invalid"
                [placeholder]="'screens.personalInformation.panel.city.placeholder' | translate"
                class="tw-w-full focus-visible:focus-visible:tw-outline-none hb-group:tw-mt-0 hb-group:tw-w-full md:tw-w-75 hb-group:md:tw-w-1/2"
                formControlName="city"
                mask="A*"
                [patterns]="specialCharactersNotAllowed"
                [dropSpecialCharacters]="false"
                iaInput
                id="input-personal-information-city"
                data-test-id="input-personal-information-city"
                type="text"
              />
            </div>
            @if (city.touched && city.hasError('required')) {
              <ia-resil-contrats-error-message
                [message]="'screens.personalInformation.panel.city.error.required' | translate"
              />
            }
          </div>
        }

        <p
          class="tw-mt-7.5 tw-text-sm hb-group:tw-text-slate-gray-2 connected:tw-text-gray"
          [innerHTML]="
            (isMobile
              ? 'screens.personalInformation.panel.noticeMobile'
              : 'screens.personalInformation.panel.notice'
            ) | translate
          "
        ></p>
      </div>
    </div>
    ··
  </ia-panel>
</form>

<div class="tw-mt-5 tw-flex tw-flex-col tw-items-center tw-justify-end tw-gap-4 md:tw-flex-row">
  <button
    (click)="onPrevious()"
    [isProcessing]="false"
    class="tw-h-10.5 tw-font-semibold hb-group:tw-rounded-3xl"
    iaButton
    id="link-personal-information-previous"
    data-test-id="link-personal-information-previous"
    size="large"
    type="button"
    variant="secondary"
  >
    {{ 'screens.personalInformation.button.previous' | translate }}
  </button>
  <button
    (click)="onNext()"
    [isProcessing]="false"
    class="tw-mt-4 tw-h-10.5 tw-font-semibold hb-group:tw-rounded-3xl md:tw-mt-0"
    iaButton
    id="link-personal-information-next"
    data-test-id="link-personal-information-next"
    size="large"
    type="button"
    variant="primary"
    [disabled]="!personalInformationForm.valid"
  >
    {{ 'screens.personalInformation.button.next' | translate }}
  </button>
</div>
